import React, { useEffect } from "react";
import { clearAuthMsg } from "../../actions/authActions";
import { connect } from "react-redux";

const BlockAccountPage = (props) => {
  useEffect(() => {
    props.clearAuthMsg();
  }, []);
  
  return (
    <div>
      <h2>Sorry! Your account has been blocked.</h2>
      <h4>
        You have violated some policies because of which we have blocked your
        account.
      </h4>
      <h5>
        Contact at maazkhansw@gmail.com or +92 347 925145, for more enquiry.
      </h5>
    </div>
  );
};

export default connect(null, { clearAuthMsg })(BlockAccountPage);
